import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const navigation = [
  ["Início", "/", "nav-home-link"],
  ["Serviços", "/servicos", "nav-services-link"],
  ["Como Funciona", "/como-funciona", "nav-how-link"],
  ["Sobre Nós", "/sobre-nos", "nav-about-link"],
  ["FAQ", "/faq", "nav-faq-link"],
  ["Contactos", "/contactos", "nav-contact-link"],
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const close = () => setOpen(false);

  return (
    <header className="site-header" data-testid="main-site-header">
      <div className="container header-inner">
        <Link to="/" className="brand" onClick={close} data-testid="brand-home-link">
          <img className="site-logo" src="/problema360-logo.png" alt="Problema360 Porto" />
        </Link>
        <button
          type="button"
          className="mobile-menu-button"
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
          data-testid="mobile-menu-button"
        >
          {open ? <X size={21} /> : <Menu size={21} />}
        </button>
        <nav className={`main-nav ${open ? "is-open" : ""}`} aria-label="Navegação principal" data-testid="main-navigation">
          {navigation.map(([label, to, testId]) => (
            <Link
              key={to}
              to={to}
              onClick={close}
              className={location.pathname === to ? "active" : ""}
              data-testid={testId}
            >
              {label}
            </Link>
          ))}
          <Link to="/marcar-servico" onClick={close} className="button button-small header-cta" data-testid="header-book-service-link">
            Marcar Serviço <ArrowUpRight size={15} />
          </Link>
        </nav>
      </div>
    </header>
  );
}
